const auth = require('./auth');
const client = require('./client');
const helper = require('./helper');
const member = require('./member');
const provider = require('./provider');
const proxy = require('./proxy');
const claim = require('./claim');
const accumulator = require('./accumulator');

module.exports = {
    ...auth,
    ...claim,
    ...client,
    ...helper,
    ...member,
    ...provider,
    ...proxy,
    ...accumulator
}